import { Box, Button, Card, Flex, theme, Typography, Link as StyledLink } from '@fe-toolkit/web-components/ssr'

import { DetailsListSeparator } from '@giffgaff/broadband-common'

import { HomeBroadband } from '@/components'

export function CeasedServiceSection() {
  return (
    <Flex
      as="section"
      flexDirection="column"
      gap={theme.spacing.mediumLarge}
      marginBottom="large"
      sx={({ theme }) => ({
        [theme.breakpoints.up('medium')]: {
          gap: theme.spacing.medium,
        },
      })}
    >
      <Flex
        flexDirection="column"
        gap={theme.spacing.small}
        sx={({ theme }) => ({
          [theme.breakpoints.up('medium')]: {
            flexDirection: 'row',
          },
        })}
      >
        <Box
          sx={({ theme }) => ({
            maxWidth: '107px',
            [theme.breakpoints.up('medium')]: {
              maxWidth: '348px',
              padding: theme.spacing.mediumLarge,
            },
          })}
        >
          <HomeBroadband width="100%" />
        </Box>
        <Flex flexDirection="column" gap={theme.spacing.small}>
          <Typography as="h2" sx={{ maxWidth: theme.layout.readableWidth }} variant="shout">
            Your broadband isn't active right now
          </Typography>
          <Typography as="p" variant="speak">
            You can easily start using giffgaff broadband again by choosing a plan and rejoining us.
          </Typography>
          <Box>
            <Button href="/broadband" isFullWidth={{ down: 'medium' }} variant="primary">
              Get back online
            </Button>
          </Box>
        </Flex>
      </Flex>
      <Box margin="0 auto" maxWidth={theme.layout.readableWidth} width="100%">
        <Typography as="h3" marginBottom="small" variant="loudBold">
          Quick links
        </Typography>
        <Card
          backgroundColor="white"
          borderRadius="medium"
          justifyContent="space-between"
          px="small"
          py="fine"
          sx={{ flexGrow: 1 }}
        >
          <Box>
            <StyledLink
              chevron
              fullWidth
              arrow="none"
              href="/orders/history/others"
              marginBottom="small"
              marginTop="small"
            >
              View payment history
            </StyledLink>
            <DetailsListSeparator colour="alto" />
            <StyledLink chevron fullWidth arrow="none" href="/profile/details" marginBottom="small" marginTop="small">
              Manage account details
            </StyledLink>
            <DetailsListSeparator colour="alto" />
            <StyledLink
              chevron
              fullWidth
              arrow="none"
              href="https://help.giffgaff.com/en/"
              marginBottom="small"
              marginTop="small"
            >
              Need help? Visit help & support
            </StyledLink>
          </Box>
        </Card>
      </Box>
    </Flex>
  )
}
